module.exports = __webpack_public_path__ + "img/Neurosurgeon.c1186515.jpg";